import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Spinner
} from "reactstrap";


// Import as svg
import { ReactComponent as AuthSVG } from "../../assets/images/auth/main.svg";

//redux
import { useDispatch, useSelector } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
// Formik validation
import { useFormik } from "formik";
import * as Yup from "yup";

// actions
import { PrimaryLogo } from "../../Components/Logo/PrimaryLogo";
import ReCaptcha from "../../Components/ReCaptcha";
import { loginUser, resetLoginFlag, socialLogin } from "../../slices/thunks";

import { useLocation } from "react-router-dom";
import { validateInviteCode } from "../../slices/inviteCode/thunk";
import { useCustomTheme } from "../../slices/theme/hooks";
import { setTheme } from "../../slices/theme/reducer";
import AuthVisual from "../../Components/Auth/AuthVisual";
// import logo from "../../assets/images/logo/logo.png";
//import images

const Login = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);
  const [inviteCode, setInviteCode] = useState(null);
  const { error, loading, errorMsg } = useSelector((state) => state.Login);
  const state = useSelector((state) => state);

  const customTheme = useCustomTheme();

  const {
    secondaryColor,
    primaryColor
  } = customTheme || {}

  const [userLogin, setUserLogin] = useState([]);
  const [passwordShow, setPasswordShow] = useState(false);

  const [loading1, setLoading1] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const inviteCodeFromUrl = queryParams.get("inviteCode");
    if (inviteCodeFromUrl) {
      setInviteCode(inviteCodeFromUrl);
    } else {
      setInitialized(true); // no invite code, skip
    }
  }, [location]);

  useEffect(() => {
    const fetchThemeFromInvite = async () => {
      if (!inviteCode) return;

      try {
        const response = await dispatch(
          validateInviteCode({
            inviteCode,
          })
        ).unwrap();

        console.log("Invite code response:", response);

        if (response.invitedBy?.theme) {
          await dispatch(setTheme(response.invitedBy.theme));
        }
      } catch (err) {
        console.error("Failed to fetch theme for invite code:", err);
      } finally {
        setInitialized(true);
      }
    };

    fetchThemeFromInvite();
  }, [inviteCode, dispatch]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: userLogin.email || "",
      password: userLogin.password || "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: async (values) => {
      try {
        setLoading1(true);
        await dispatch(loginUser(values, props.router.navigate));
        // if (error || errorMsg) {
        //   setLoading1(false);
        // }
      } catch (error) {
        console.log(error);
        setLoading1(false);
      }
    },
  });

  const signIn = (type) => {
    dispatch(socialLogin(type, props.router.navigate));
  };

  //handleTwitterLoginResponse
  // const twitterResponse = e => {}

  //for facebook and google authentication
  const socialResponse = (type) => {
    signIn(type);
  };

  useEffect(() => {
    if (!loading && (error || errorMsg)) {
      setLoading1(false);
    }
  }, [loading, error, errorMsg]);

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        setLoading1(false);
        dispatch(resetLoginFlag());
      }, 3000);
    }
  }, [dispatch, errorMsg]);


  if (!initialized) {
    return (
      <div className="text-center my-4">
        <Spinner size="sm" color="primary" />
        <p className="mt-2">Loading...</p>
      </div>
    );
  }

  return (
    <React.Fragment>

      <ReCaptcha />
      <div className="auth-page-content">
        <Row className="w-100">
          <AuthVisual />
          <Col lg="6" md="12" className="auth-form-panel">
            <Card className="card-auth">
              <CardBody className="pb-2">
                <div className="text-center">
                  <div
                    style={{
                      width: 'max-content', alignSelf: 'center',
                      margin: '0 auto',
                      borderRadius: '0.5rem',
                      backgroundColor: secondaryColor
                    }}
                    className="text-center my-2 mb-4 p-3 d-flex align-items-center" >
                    <PrimaryLogo />
                  </div>
                  <h2>Welcome Back!</h2>
                  <p className="text-muted">Sign in to continue</p>
                </div>
                <hr className="my-4" />
                {error && <Alert color="danger">{error}</Alert>}
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                  action="#"
                >
                  <div className="mb-3">
                    <Label htmlFor="email" className="form-label">
                      Email
                    </Label>
                    <Input
                      name="email"
                      className="form-control bg-light"
                      placeholder="Enter email address"
                      type="email"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.email || ""}
                      invalid={
                        validation.touched.email && validation.errors.email
                          ? true
                          : false
                      }
                    />
                    {validation.touched.email && validation.errors.email ? (
                      <FormFeedback type="invalid">
                        {validation.errors.email}
                      </FormFeedback>
                    ) : null}
                  </div>

                  <div className="mb-3">
                    <Label className="form-label" htmlFor="password-input">
                      Password
                    </Label>
                    <div className="position-relative auth-pass-inputgroup mb-3">
                      <Input
                        name="password"
                        value={validation.values.password || ""}
                        type={passwordShow ? "text" : "password"}
                        className="form-control pe-5 bg-light"
                        placeholder="Enter Password"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        invalid={
                          validation.touched.password &&
                            validation.errors.password
                            ? true
                            : false
                        }
                      />
                      {validation.touched.password &&
                        validation.errors.password ? (
                        <FormFeedback type="invalid">
                          {validation.errors.password}
                        </FormFeedback>
                      ) : null}
                      <button
                        className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                        type="button"
                        onClick={() => setPasswordShow(!passwordShow)}
                        id="password-addon"
                      >
                        <i className="ri-eye-fill align-middle"></i>
                      </button>
                    </div>{" "}
                    <div className="float-end mb-4">
                      <Link to="/forgot-password" className="text-primary">
                        Forgot password?
                      </Link>
                    </div>
                  </div>

                  <div className="mt-4">
                    <Button
                      color="primary"
                      disabled={loading1 && (!error || !errorMsg)}
                      className="btn btn-primary w-100"
                      type="submit"
                    >
                      {loading1 && (!error || !errorMsg) ? (
                        <Spinner size="sm" className="me-2">
                          Loading...
                        </Spinner>
                      ) : (
                        "Sign In"
                      )}
                    </Button>
                  </div>
                </Form>
                <div className="text-center mt-5">
                  <p>
                    Don't have an account?{" "}
                    <Link
                      to="/register"
                      className="fw-semibold text-primary text-decoration-underline"
                    >
                      Signup
                    </Link>
                  </p>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment >

  );
};

export default withRouter(Login);
